/* MOCK TEMPORÁRIO DESATIVADO
// MOCK TEMPORÁRIO: a importação e as chamadas reais estão comentadas para
// permitir a avaliação visual das telas sem depender do backend.
// import Api from './api';

// const BASE = '/statusemailnotifications';
const MOCK_READ_DELAY = 650;
const MOCK_ACTION_DELAY = 150;

const statusNames = {
  10: 'Novo',
  20: 'Em atendimento',
  30: 'Aguardando documento',
  40: 'Resolvido',
};

const templateNames = {
  1000: 'Solicitação de documento',
  1001: 'Lembrete de documento pendente',
  1002: 'Chamado concluído',
};

let mockNotifications = [
  {
    id: 2000,
    statusid: 30,
    statusname: 'Aguardando documento',
    templateid: 1000,
    templatename: 'Solicitação de documento',
    active: true,
  },
  {
    id: 2001,
    statusid: 40,
    statusname: 'Resolvido',
    templateid: 1002,
    templatename: 'Chamado concluído',
    active: true,
  },
  {
    id: 2002,
    statusid: 20,
    statusname: 'Em atendimento',
    templateid: 1001,
    templatename: 'Lembrete de documento pendente',
    active: false,
  },
];

let mockReminders = {
  2000: [
    {
      id: 3000,
      statusemailnotificationid: 2000,
      templateid: 1001,
      templatename: 'Lembrete de documento pendente',
      waithours: 24,
      usebusinessdays: true,
      order: 1,
      active: true,
      eligibilitymode: 'alwayssend',
    },
    {
      id: 3001,
      statusemailnotificationid: 2000,
      templateid: 1001,
      templatename: 'Lembrete de documento pendente',
      waithours: 72,
      usebusinessdays: true,
      order: 2,
      active: true,
      eligibilitymode: 'alwayssend',
    },
  ],
  2001: [
    {
      id: 3002,
      statusemailnotificationid: 2001,
      templateid: 1002,
      templatename: 'Chamado concluído',
      waithours: 2,
      usebusinessdays: false,
      order: 1,
      active: false,
      eligibilitymode: 'alwayssend',
    },
  ],
  2002: [],
};

const clone = value => JSON.parse(JSON.stringify(value));
const respond = (value, delay = MOCK_ACTION_DELAY) =>
  new Promise(resolve => setTimeout(() => resolve(clone(value)), delay));
const success = (data, count = 0) => ({
  success: true,
  data,
  count,
  message: '',
});
const failure = message => ({
  success: false,
  data: null,
  count: 0,
  message,
});
const sameId = (left, right) => String(left) === String(right);
const nextId = (collection, fallback) =>
  collection.reduce((maximum, item) => Math.max(maximum, Number(item.id)), fallback) +
  1;
const getTemplateName = id =>
  templateNames[id] || `Template de e-mail #${id}`;

export const list = async ({
  search = '',
  active,
  page = 1,
  pagesize = 20,
} = {}) => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.get(BASE, { params: { search, active, page, pagesize } });
  const normalizedSearch = String(search).trim().toLowerCase();
  const filtered = mockNotifications.filter(item => {
    const matchesSearch =
      !normalizedSearch ||
      item.statusname.toLowerCase().includes(normalizedSearch) ||
      item.templatename.toLowerCase().includes(normalizedSearch);
    const matchesActive =
      active === undefined ||
      active === null ||
      active === '' ||
      String(item.active) === String(active);
    return matchesSearch && matchesActive;
  });
  const start = (Number(page) - 1) * Number(pagesize);
  const data = filtered
    .slice(start, start + Number(pagesize))
    .map(item => ({ ...item, reminders: mockReminders[item.id] || [] }));
  return respond(success(data, filtered.length), MOCK_READ_DELAY);
};

export const getById = async id => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.get(`${BASE}/${id}`);
  const notification = mockNotifications.find(item => sameId(item.id, id));
  return respond(
    notification
      ? success(notification)
      : failure('Notificação mockada não encontrada.'),
    MOCK_READ_DELAY
  );
};

export const create = async data => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.post(BASE, data);
  const notification = {
    id: nextId(mockNotifications, 1999),
    ...data,
    statusname: statusNames[data.statusid] || `Status #${data.statusid}`,
    templatename: getTemplateName(data.templateid),
  };
  mockNotifications = [...mockNotifications, notification];
  mockReminders[notification.id] = [];
  return respond(success(notification));
};

export const update = async (id, data) => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.put(`${BASE}/${id}`, data);
  const index = mockNotifications.findIndex(item => sameId(item.id, id));
  if (index < 0) {
    return respond(failure('Notificação mockada não encontrada.'));
  }
  mockNotifications[index] = {
    ...mockNotifications[index],
    ...data,
    statusname: statusNames[data.statusid] || `Status #${data.statusid}`,
    templatename: getTemplateName(data.templateid),
  };
  return respond(success(mockNotifications[index]));
};

export const setActive = async (id, active) => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.put(`${BASE}/${id}/active`, { active });
  const index = mockNotifications.findIndex(item => sameId(item.id, id));
  if (index < 0) {
    return respond(failure('Notificação mockada não encontrada.'));
  }
  mockNotifications[index] = {
    ...mockNotifications[index],
    active: Boolean(active),
  };
  return respond(success(mockNotifications[index]));
};

export const deleteById = async id => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.delete(`${BASE}/${id}`);
  const exists = mockNotifications.some(item => sameId(item.id, id));
  if (!exists) return respond(failure('Notificação mockada não encontrada.'));
  mockNotifications = mockNotifications.filter(item => !sameId(item.id, id));
  delete mockReminders[id];
  return respond(success(true));
};

export const listReminders = async notificationid => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.get(`${BASE}/${notificationid}/reminders`);
  return respond(
    success(mockReminders[notificationid] || []),
    MOCK_READ_DELAY
  );
};

export const createReminder = async (notificationid, data) => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.post(`${BASE}/${notificationid}/reminders`, data);
  const allReminders = Object.values(mockReminders).flat();
  const reminder = {
    id: nextId(allReminders, 2999),
    statusemailnotificationid: Number(notificationid),
    ...data,
    templatename: getTemplateName(data.templateid),
    eligibilitymode: 'alwayssend',
  };
  mockReminders[notificationid] = [
    ...(mockReminders[notificationid] || []),
    reminder,
  ];
  return respond(success(reminder));
};

export const updateReminder = async (notificationid, id, data) => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.put(`${BASE}/${notificationid}/reminders/${id}`, data);
  const reminders = mockReminders[notificationid] || [];
  const index = reminders.findIndex(item => sameId(item.id, id));
  if (index < 0) return respond(failure('Lembrete mockado não encontrado.'));
  reminders[index] = {
    ...reminders[index],
    ...data,
    templatename: getTemplateName(data.templateid),
    eligibilitymode: 'alwayssend',
  };
  mockReminders[notificationid] = reminders;
  return respond(success(reminders[index]));
};

export const setReminderActive = async (notificationid, id, active) => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.put(`${BASE}/${notificationid}/reminders/${id}/active`, { active });
  const reminders = mockReminders[notificationid] || [];
  const index = reminders.findIndex(item => sameId(item.id, id));
  if (index < 0) return respond(failure('Lembrete mockado não encontrado.'));
  reminders[index] = { ...reminders[index], active: Boolean(active) };
  mockReminders[notificationid] = reminders;
  return respond(success(reminders[index]));
};

export const deleteReminder = async (notificationid, id) => {
  // Requisição real temporariamente desabilitada:
  // const response = await Api.delete(`${BASE}/${notificationid}/reminders/${id}`);
  const reminders = mockReminders[notificationid] || [];
  const exists = reminders.some(item => sameId(item.id, id));
  if (!exists) return respond(failure('Lembrete mockado não encontrado.'));
  mockReminders[notificationid] = reminders.filter(item => !sameId(item.id, id));
  return respond(success(true));
};
*/

import Api from './api';

const BASE = '/statusemailnotifications';

const getErrors = payload => {
  const errors = payload?.errors;
  if (Array.isArray(errors)) return errors.join(' ');
  if (errors && typeof errors === 'object') {
    return Object.values(errors).flat().join(' ');
  }
  return payload?.message || '';
};

const successResult = response => ({
  success: Boolean(response.data?.success),
  data: response.data?.data,
  count: response.data?.count ?? 0,
  message: getErrors(response.data),
});

const errorResult = error => ({
  success: false,
  data: null,
  count: 0,
  message: getErrors(error.response?.data),
});

export const list = async ({
  search = '',
  active,
  page = 1,
  pagesize = 20,
} = {}) => {
  try {
    const response = await Api.get(BASE, {
      params: { search, active, page, pagesize },
    });
    const result = successResult(response);
    return { ...result, data: result.data || [] };
  } catch (error) {
    return { ...errorResult(error), data: [] };
  }
};

export const getById = async id => {
  try {
    return successResult(await Api.get(`${BASE}/${id}`));
  } catch (error) {
    return errorResult(error);
  }
};

export const create = async data => {
  try {
    return successResult(await Api.post(BASE, data));
  } catch (error) {
    return errorResult(error);
  }
};

export const update = async (id, data) => {
  try {
    return successResult(await Api.put(`${BASE}/${id}`, data));
  } catch (error) {
    return errorResult(error);
  }
};

export const setActive = async (id, active) => {
  try {
    return successResult(await Api.put(`${BASE}/${id}/active`, { active }));
  } catch (error) {
    return errorResult(error);
  }
};

export const deleteById = async id => {
  try {
    return successResult(await Api.delete(`${BASE}/${id}`));
  } catch (error) {
    return errorResult(error);
  }
};

export const listReminders = async notificationid => {
  try {
    const result = successResult(
      await Api.get(`${BASE}/${notificationid}/reminders`)
    );
    return { ...result, data: result.data || [] };
  } catch (error) {
    return { ...errorResult(error), data: [] };
  }
};

export const createReminder = async (notificationid, data) => {
  try {
    return successResult(
      await Api.post(`${BASE}/${notificationid}/reminders`, data)
    );
  } catch (error) {
    return errorResult(error);
  }
};

export const updateReminder = async (notificationid, id, data) => {
  try {
    return successResult(
      await Api.put(`${BASE}/${notificationid}/reminders/${id}`, data)
    );
  } catch (error) {
    return errorResult(error);
  }
};

export const setReminderActive = async (notificationid, id, active) => {
  try {
    return successResult(
      await Api.put(`${BASE}/${notificationid}/reminders/${id}/active`, {
        active,
      })
    );
  } catch (error) {
    return errorResult(error);
  }
};

export const deleteReminder = async (notificationid, id) => {
  try {
    return successResult(
      await Api.delete(`${BASE}/${notificationid}/reminders/${id}`)
    );
  } catch (error) {
    return errorResult(error);
  }
};
